import React, { Component } from "react";
import { signOutAction } from "../../actions/authActions";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ButtonLogout extends Component {
  signOut = () => {
    this.props.signOutAction();
  };

  userIcons = (role) => {
    switch (role) {
      case "Teacher":
        return "graduation-cap";
      case "Student":
        return "user";
      case "Superuser":
        return "user-ninja";
      case "Admin":
        return "user-plus";
      default:
        return "user";
    }
  };

  render() {
    var role = localStorage.getItem("role") ? localStorage.getItem("role") : "";
    var email = localStorage.getItem("email");

    return (
      <div className="logout--button-container">
        <div className="logout--button" onClick={this.signOut}>
          <p className="logout--text">
            <FormattedMessage id="LogOut" />
          </p>
        </div>
        <div className="logout--icon-container">
          <FontAwesomeIcon icon={this.userIcons(role)} />
        </div>
        <div className="logout--email-container">
          <span>{email}</span>
        </div>
      </div>
    );
  }
}

export default connect(null, { signOutAction })(ButtonLogout);
